/**
 * File: web/src/components/Footer.tsx
 * ==================================
 *
 * Site footer (support + contact information)
 *
 * Purpose:
 * - Provide consistent help/contact information across all routes.
 * - Keep operational guidance visible for end users who get stuck (auth issues, allowlist, etc.).
 *
 * When used:
 * - Rendered by App.tsx below the router content so it appears on every page.
 *
 * Learner note:
 * - This is intentionally a "dumb" presentational component:
 *   - no state, no side effects, no dependencies on config/auth
 *   - easy to keep stable and safe
 */

export function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="container footer-inner">
        <div>
          <div className="footer-title">Need help?</div>
          <div className="footer-text">
            Reach out to the WSU Contact that invited you to upload.
          </div>
          <div className="footer-text">
            For technical issues, email{" "}
            <a className="footer-mail" href="mailto:ats.aoi@wsu.edu">
              ats.aoi@wsu.edu
            </a>
            .
          </div>
        </div>
      </div>
    </footer>
  );
}
